import Index from './index.vue'
import Create from './components/Create.vue'
import List from './components/List.vue'
import Search from './view/Search.vue'
import Home from './view/Home.vue'
import Profile from './view/Profile.vue'
import Feedback from '../Feedback/components/List'

export default [
  {
    path: 'tickets',
    name: 'ticket',
    component: Index,
    title: 'Ticket',
    redirect: { name: 'ticket-home' },
    children: [
      {
        path: 'create',
        name: 'ticket-create',
        component: Create,
      },
      {
        path: 'search',
        name: 'search-ticket',
        component: Search,
      },
      {
        path: 'list',
        name: 'ticket-list',
        component: List,
      },
      {
        path: 'feedback',
        name: 'feedback-list',
        component: Feedback,
      },
      {
        path: 'profile/:id',
        name: 'ticket-profile',
        component: Profile,
      },
      {
        path: 'home',
        name: 'ticket-home',
        component: Home,
      },
    ],
  },
]
